import React, { Fragment, useState } from 'react'
import { Button, Col, Form, Icon, Upload } from 'antd'


function DocumentUpload(props) {
  const [fileList, setFileList] = useState([])
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }
  const handleSubmit = (e) => {
    const template = props.template
    e.preventDefault()
    props.form.validateFields((err, values) => {
      if (!err) {
        // adding template to uploaded files
        const keyValues = Object.keys(values.upload)
        let newData = keyValues.map((valueKey) => {
          let newVK = {}
          newVK.files = values.upload[valueKey]
          newVK.template = template.find((file) => {
            return file.key === valueKey
          })
          return newVK
        })
        props.handleUpload(newData)
      }
    })
  }
  let { template, project, updating } = props
  let alreadyUploadedDocument = project.project.document
  let forDeletion = alreadyUploadedDocument.map((aud) => template.findIndex((t) => t.label === aud.label))
  template = template.filter((t, i) => !forDeletion.includes(i))

  const uploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file)
      const newFileList = fileList.slice()
      newFileList.splice(index, 1)
      setFileList(newFileList)
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file])
      return false
    },
    fileList,
  }

  const { getFieldDecorator } = props.form
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  }
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 20, offset: 4 },
    },
  }

  const formItems = template.map((k) => {
    return (
      <Form.Item {...formItemLayout} label={k.label} key={k.key} extra={k.desc}>
        {getFieldDecorator(`upload.${k.key}`, {
          valuePropName: `fileList`,
          getValueFromEvent: normFile,
        })(
          <Upload name={k.label} {...uploadProps}>
            <Button>
              <Icon type="upload" /> Click to upload
            </Button>
          </Upload>
        )}
      </Form.Item>
    )
  })

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        {formItems}
        <Form.Item {...formItemLayoutWithOutLabel}>
          <Col span={24}>
            <Button type="primary" htmlType="submit" loading={updating}>
              Submit
            </Button>
          </Col>
        </Form.Item>
      </Form>
    </Fragment>
  )
}

export default Form.create()((DocumentUpload))
